var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledThumbsDown = function SvgFilledThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.3c0-1.1-.9-2-2-2-1.7 0-3 1.3-3 3v4c0 1.7 1.3 3 3 3 1.1 0 2-.9 2-2zM8.4 17.4c-.2 1-.1 2 .4 2.9.1.1.1.2.3.4.1.1.1.2.2.2.4.4 1 .5 1.4.1l.2-.2 4.1-4.5c1-1.1 1.5-1.6 1.7-2.3.3-.7.3-1.4.3-2.8v-1c0-2.8 0-4.2-.9-5-.9-.9-2.3-.9-5.2-.9h-.5c-2.4 0-3.5 0-4.5.5-.1.1-.2.1-.2.2-.9.6-1.4 1.7-2.4 3.8C2.2 11 1.7 12.2 2.2 13c.1.1.1.2.2.3.6.8 1.9.8 4.5.8h.4c.8 0 1.1 0 1.4.2.1.1.3.3.3.5.1.3 0 .6-.2 1.3l-.3.9c0 .2-.1.3-.1.4"
  })));
};
export default SvgFilledThumbsDown;